import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RepoService } from '../../shared/services/repo.service';
import { UUID } from 'angular2-uuid';
import { AuthenticateService } from '../../shared/services/authenticate.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { InputsService } from '../../shared/services/inputs.service';
import moment from 'moment';
import { CropsService } from 'src/app/shared/services/crops.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { FileUploadService } from 'src/app/shared/services/fileupload.service';
import { TokenStorageService } from 'src/app/shared/services/token.service';
@Component({
  selector: 'app-inputs',
  templateUrl: './inputs.component.html',
  styleUrls: ['./inputs.component.sass']
})
export class InputsComponent implements OnInit {

  ProductForm: FormGroup;
  inputType: string = 'seeds';
  showDetails: boolean = true;
  urls = [];
  imageNameList = [];
  imageUploadService: string = '';
  uploadFileList: any = [];
  imgUrl = this.authService.s3url();
  public loading: boolean;
  groupName: string;
  cropDataArray: any = [];
  showcrop: any[] = [];
  seedsDataArray: any = [];
  commonnameArray: any = [];
  technicalnameArray: any = [];
  productObj: any = {};
  productType: any;
  showvariants: boolean = false;
  tempArray: any = [];
  multiArray: any = [];
  collectionSize: any;
  previousPage: any;
  skip: number;
  page = 1;
  searchStr: string = '';
  showsearchdata: boolean = true;
  type: string = 'save';
  size: number = 0;
  unit: string = '';
  price: number = 0;
  uploadMultipleFileList = [];
  cropuuid: string = '';
  tempcropArray: any = [];
  ferticollectionSize: any;
  fertiPreviousPage: any;
  fertiSkip: number;
  fertilizersDataArray: any = [];
  pesticollectionSize: any;
  pestiPreviousPage: any;
  pestiSkip: number;
  pesticidesDataArray: any = [];
  typeId: string = 'seeds';
  showAlert: boolean = false;
  selectedProductId: any;
  selectedTechnicalName: any;
  sizesArray: any[] = [];

  constructor(private formBuilder: FormBuilder,
    private tokenService: TokenStorageService,
    private authService: AuthenticateService,
    private profileService: ProfileService,
    private fileUploadService: FileUploadService,
    private inputsService: InputsService,
    private cropsService: CropsService) { }
  ngOnInit() {
    this.groupName = this.tokenService.getGroup();
    this.getAllSeeds();
    this.getcropvarieties();
    this.getFertilizerData();
    // this.getAllFertilizers();
    // this.getAllPesticides();
    this.ProductForm = this.formBuilder.group({
      price: [''],
      description: ['', Validators.required],
      productName: ['', Validators.required],
      manufacturerName: ['', Validators.required],
      size: [''],
      unit: [''],
      sku: ['', Validators.required],
      barCode: ['', Validators.required]
    });
  }

  getcropvarieties() {
    let obj = {
      group: this.groupName,
    }
    this.cropDataArray = [];
    this.tempcropArray = [];
    this.cropsService.getCropVarieties(obj).then((data: any) => {
      if (data.length > 0) {
        data.sort(function (a, b) {
          return a.varietyName.localeCompare(b.varietyName);
        })
        for (var i = 0; i < data.length; i++) {
          this.cropDataArray = this.cropDataArray.concat(data[i].varietyName)
          let tobj = {
            varietyName: data[i].varietyName,
            cropId: data[i].cropId
          }
          this.tempcropArray.push(tobj)
        }
      }
    })
  }

  getFertilizerData() {
    let obj = {
      group: this.groupName
    }
    this.commonnameArray = [];
    this.technicalnameArray = [];
    this.profileService.getAllProducts(obj).then((data: any) => {
      if (data.length > 0) {
        data.sort(function (a, b) {
          return a.tradeName.localeCompare(b.tradeName);
        })
        this.commonnameArray = [];
        for (var i = 0; i < data.length; i++) {
          this.commonnameArray = this.commonnameArray.concat(data[i].tradeName)
        }
        data.sort(function (a, b) {
          return a.technicalName.localeCompare(b.technicalName);
        })
        for (var i = 0; i < data.length; i++) {
          let obj = {
            productuuId: data[i].productuuId,
            technicalName: data[i].technicalName
          }
          this.technicalnameArray.push(obj);
          // this.technicalnameArray = this.technicalnameArray.concat(data[i].technicalName);
        }
      }
    })
  }
  getProductId(rec) {
    console.log(rec, this.technicalnameArray);
    this.selectedProductId = rec;
    let temp = this.technicalnameArray.find(item => item.productuuId == rec);
    this.selectedTechnicalName = temp.technicalName;
  }
  getAllSeeds() {
    this.page = 1;
    this.loading = true;
    this.showsearchdata = true;
    this.seedsDataArray = [];
    var options = {
      group: this.groupName,
      productType: 'Seeds',
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: 0,
      // }
    }
    this.inputsService.getInputs(options).then((data: any) => {
      if (data.length > 0) {
        this.seedsDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    })
    var count = { group: this.groupName, productType: 'Seeds' }
    this.inputsService.getInputsCount(count).then((data: any) => {
      if (data.length > 0) {
        this.collectionSize = data[0].size
      }
    });
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 20) - 20;
      this.previousPage = pageNumber;
      this.loadData(this.skip);
    }
  }

  loadData(skip) {
    this.loading = true;
    this.seedsDataArray = [];
    var options = {
      group: this.groupName,
      productType: 'Seeds',
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip,
      // }
    }
    this.inputsService.getInputs(options).then((data: any) => {
      if (data.length > 0) {
        this.seedsDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName, productType: 'Seeds' }
    this.inputsService.getInputsCount(count).then((data: any) => {
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  getAllFertilizers() {
    this.page = 1;
    this.loading = true;
    this.showsearchdata = true;
    this.fertilizersDataArray = [];
    var options = {
      group: this.groupName,
      productType: 'Fertilizer',
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: 0,
      // }
    }
    this.inputsService.getInputs(options).then((data: any) => {
      if (data.length > 0) {
        this.fertilizersDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    })
    var count = { group: this.groupName, productType: 'Fertilizer' }
    this.inputsService.getInputsCount(count).then((data: any) => {
      if (data.length > 0) {
        this.ferticollectionSize = data[0].size;
      }
    });
  }

  loadFertilizersPage(fertiPageNumber: number) {
    this.loading = true;
    if (fertiPageNumber !== this.fertiPreviousPage) {
      this.fertiSkip = (fertiPageNumber * 20) - 20;
      this.fertiPreviousPage = fertiPageNumber;
      this.loadFertilizersData(this.skip);
    }
  }

  loadFertilizersData(skip) {
    this.loading = true;
    this.fertilizersDataArray = [];
    var options = {
      group: this.groupName,
      productType: 'Fertilizer',
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip,
      // }
    }
    this.inputsService.getInputs(options).then((data: any) => {
      if (data.length > 0) {
        this.fertilizersDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName, productType: 'Fertilizer' }
    this.inputsService.getInputsCount(count).then((data: any) => {
      if (data.length > 0) {
        this.ferticollectionSize = data[0].size;
      }
    });
  }

  getAllPesticides() {
    this.page = 1;
    this.loading = true;
    this.showsearchdata = true;
    this.pesticidesDataArray = [];
    var options = {
      group: this.groupName,
      productType: 'Pesticides',
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: 0,
      // }
    }
    this.inputsService.getInputs(options).then((data: any) => {
      if (data.length > 0) {
        this.pesticidesDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    })
    var count = { group: this.groupName, productType: 'Pesticides' }
    this.inputsService.getInputsCount(count).then((data: any) => {
      if (data.length > 0) {
        this.pesticollectionSize = data[0].size;
      }
    });
  }

  loadPesticidesPage(pestiPageNumber: number) {
    this.loading = true;
    if (pestiPageNumber !== this.pestiPreviousPage) {
      this.pestiSkip = (pestiPageNumber * 20) - 20;
      this.pestiPreviousPage = pestiPageNumber;
      this.loadpesticidesData(this.pestiSkip);
    }
  }

  loadpesticidesData(skip) {
    this.loading = true;
    this.pesticidesDataArray = [];
    var options = {
      group: this.groupName,
      productType: 'Pesticides',
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip,
      // }
    }
    this.inputsService.getInputs(options).then((data: any) => {
      if (data.length > 0) {
        this.pesticidesDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName, productType: 'Pesticides' }
    this.inputsService.getInputsCount(count).then((data: any) => {
      if (data.length > 0) {
        this.pesticollectionSize = data[0].size;
      }
    });
  }

  getAllProducts() {
    this.getAllSeeds();
    this.getAllFertilizers();
    this.getAllPesticides();
  }

  onselectproductType(type) {
    this.productType = '';
    this.productType = type;
    this.showvariants = false;
    this.imageNameList = [];
    this.urls = [];
    this.uploadFileList = [];
    this.uploadMultipleFileList = [];
    this.sizesArray = [];
    if (type == 'Seeds') {
      this.productObj = { price: '', description: '', productName: '', varietyName: '', varietyCode: '', manufacturerName: '', size: 0, unit: '', sku: '', barCode: '', productImages: [] };
      this.ProductForm = this.formBuilder.group({
        price: ['', Validators.required],
        description: ['', Validators.required],
        productName: ['', Validators.required],
        varietyName: ['', Validators.required],
        varietyCode: ['', Validators.required],
        manufacturerName: ['', Validators.required],
        size: [''],
        unit: [''],
        sku: ['', Validators.required],
        barCode: ['', Validators.required]
      });
      this.showcrop[1] = true;
      this.showcrop[2] = false;
    } else {
      this.productObj = { price: '', description: '', productName: '', varietyName: '', commonName: '', technicalName: '', chemicalCode: '', manufacturerName: '', size: 0, unit: '', sku: '', barCode: '', productImages: [] };
      this.ProductForm = this.formBuilder.group({
        price: [''],
        description: ['', Validators.required],
        productName: ['', Validators.required],
        commonName: ['', Validators.required],
        technicalName: ['', Validators.required],
        chemicalCode: ['', Validators.required],
        manufacturerName: ['', Validators.required],
        varietyName: ['', Validators.required],
        size: [''],
        unit: [''],
        sku: ['', Validators.required],
        barCode: ['', Validators.required]
      });
      this.showcrop[2] = true;
      this.showcrop[1] = false;
    }
  }

  onselectvarietyname(crop) {
    this.cropuuid = '';
    for (let i = 0; i < this.tempcropArray.length; i++) {
      if (crop == this.tempcropArray[i].varietyName) {
        this.cropuuid = this.tempcropArray[i].cropId;
      }
    }
  }

  selectvariants(event) {
    if (event.target.checked == false) {
      this.showAlert = true;
      this.tempArray = [];
      this.size = null;
    }
    this.showvariants = !this.showvariants;
  }

  restrictAlphabets(e) {
    var x = e.which || e.keycode;
    if ((x >= 48 && x <= 57) || x == 8 ||
      (x >= 35 && x <= 40) || x == 46)
      return true;
    else
      return false;
  }

  editproductData(data) {
    this.showAlert = false;
    this.showDetails = false;
    this.imageNameList = [];
    this.uploadFileList = [];
    this.uploadMultipleFileList = [];
    this.urls = [];
    if (data.productType == 'Seeds') {
      this.productObj = { price: '', description: '', productName: '', varietyName: '', varietyCode: '', manufacturerName: '', size: null, unit: '', sku: '', barCode: '', productImages: [] };
      this.ProductForm = this.formBuilder.group({
        price: [''],
        description: ['', Validators.required],
        productName: ['', Validators.required],
        varietyName: ['', Validators.required],
        varietyCode: ['', Validators.required],
        manufacturerName: ['', Validators.required],
        size: [''],
        unit: [''],
        sku: ['', Validators.required],
        barCode: ['', Validators.required]
      });
      this.showcrop[1] = true;
      this.showcrop[2] = false;
      this.productObj.varietyName = data.varietyName;
      this.productObj.varietyCode = data.varietyCode;
    } else {
      this.productObj = { price: '', description: '', productName: '', varietyName: '', commonName: '', technicalName: '', chemicalCode: '', manufacturerName: '', size: null, unit: '', sku: '', barCode: '', productImages: [] };
      this.ProductForm = this.formBuilder.group({
        price: [''],
        description: ['', Validators.required],
        productName: ['', Validators.required],
        commonName: ['', Validators.required],
        technicalName: ['', Validators.required],
        chemicalCode: ['', Validators.required],
        manufacturerName: ['', Validators.required],
        varietyName: ['', Validators.required],
        size: [''],
        unit: [''],
        sku: ['', Validators.required],
        barCode: ['', Validators.required]
      });
      this.showcrop[2] = true;
      this.showcrop[1] = false;
      this.productObj.commonName = data.commonName;
      // this.productObj.technicalName = data.technicalName;
      this.productObj.chemicalCode = data.chemicalCode;
      let temp = this.technicalnameArray.find(item => item.technicalName == data.technicalName);
      this.productObj.technicalName = temp && temp != 'undefined' ? temp.productuuId : '';
    }
    this.productObj = data;
    this.productType = data.productType;
    this.size = data.size;
    this.unit = data.unit;
    this.price = data.price ? data.price : data.packingPrice;
    this.productObj.productId = data.productId
    this.imageNameList = data.productImages;
    for (var i = 0; i < data.productImages.length; i++) {
      this.urls.push(this.imgUrl + data.productImages[i]);
      this.uploadFileList.push(this.imgUrl + data.productImages[i]);
    }
    this.type = 'update';
  }

  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split('/')[0] == 'image') {
          var reader = new FileReader()
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
          }
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService = 'var_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
          this.imageNameList.push(this.imageUploadService);
          const formData: FormData = new FormData();
          formData.set('file', event.target.files[i], this.imageUploadService);
          formData.append('name', this.imageUploadService);
          this.uploadFileList.push(formData);
          this.uploadMultipleFileList.push(formData);
        }
      }
    }
  }

  uploadFileToActivity() {
    for (var i = 0; i < this.uploadFileList.length; i++) {
      this.fileUploadService.uploadMultipleFiles(this.uploadFileList[i], this.imageUploadService);
    }
  }

  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
  }

  onImgError(event) {
    event.target.src = this.imgUrl + 'agri_logo.png';
  }

  addmultipleSize(number) {
    let obj = {
      size: this.size,
      unit: this.unit,
      price: this.price
    }
    this.sizesArray.push(obj);
    this.size = null;
    this.price = 0;
    this.unit = null;
    if (number != undefined && number != '') {
      this.tempArray = this.tempArray.concat(number);
      this.size = null;
    }
  }

  addForms() {
    this.cropuuid = '';
    this.showDetails = false;
    this.productType = null;
    this.showvariants = false;
    this.ProductForm.reset();
    this.imageNameList = [];
    this.multiArray = [];
    this.urls = [];
    this.uploadFileList = [];
    this.uploadMultipleFileList = [];
    this.tempArray = [];
    this.sizesArray = [];
    this.size = null;
    this.type = 'save';
  }

  backTomain() {
    this.showDetails = true;
    this.showcrop[1] = false;
    this.showcrop[2] = false;
    this.showvariants = false;
    this.productType = null;
    this.ProductForm.reset();
    this.imageNameList = [];
    this.multiArray = [];
    this.urls = [];
    this.uploadFileList = [];
    this.uploadMultipleFileList = [];
    this.tempArray = [];
    this.sizesArray = [];
    this.size = null;
    this.getAllSeeds();
    this.getAllFertilizers();
    this.getAllPesticides();
  }

  saveData() {
    this.loading = true;
    var pobj;
    let uuid = UUID.UUID();
    this.productObj['productId'] = uuid;
    this.productObj.productType = this.productType;
    this.productObj['varietyuuid'] = this.cropuuid;
    this.productObj.productImages = this.imageNameList;
    this.productObj.group = this.groupName;
    if (this.imageUploadService && this.imageUploadService.length > 0) {
      this.uploadFileToActivity();
    }
    if (this.tempArray.length == 1) {
      pobj = this.productObj;
      pobj['chemicalId'] = this.selectedProductId;
      pobj['size'] = this.sizesArray[0].size;
      pobj['unit'] = this.sizesArray[0].unit;
      pobj['price'] = this.sizesArray[0].mrpPrice;
      pobj['packingPrice'] = this.sizesArray[0].price;
      if (this.productObj.productType != 'Seeds') {
        pobj['technicalName'] = this.selectedTechnicalName;
      }
      this.inputsService.saveSingleInput(pobj).then((data: any) => {
        if (data) {
          Swal({ title: "Saved successfully" })
          this.getAllSeeds();
          this.getAllFertilizers();
          this.getAllPesticides();
          this.ProductForm.reset();
          this.imageNameList = [];
          this.urls = [];
          this.uploadFileList = [];
          this.uploadMultipleFileList = [];
          this.tempArray = [];
          this.size = null;
          this.showDetails = true;
          this.showcrop[1] = false;
          this.showcrop[2] = false;
          this.showvariants = false;
          this.productType = null;
          this.loading = false;
        } else {
          this.loading = false;
          Swal.fire(
            'Error',
            'Data not Submitted (please contact admin)',
            'error'
          )
        }
      })
    } else if (this.tempArray.length > 1) {
      let groupId = UUID.UUID();
      for (let i = 0; i < this.sizesArray.length; i++) {
        let muuid = UUID.UUID();
        let obj = {
          productType: this.productObj.productType,
          // price: this.sizesArray[i].price,
          packingPrice: this.sizesArray[i].price,
          description: this.productObj.description,
          productName: this.productObj.productName,
          manufacturerName: this.productObj.manufacturerName,
          varietyName: this.productObj.varietyName,
          varietyuuid: this.cropuuid,
          size: this.sizesArray[i].size,
          unit: this.sizesArray[i].unit,
          price: this.sizesArray[i].mrpPrice,
          sku: this.productObj.sku,
          barCode: this.productObj.barCode,
          productImages: this.imageNameList,
          group: this.groupName,
          productId: muuid,
          productgroup: this.productObj.productName + '_' + groupId,
        }
        if (this.productObj.productType == 'Seeds') {
          obj['varietyCode'] = this.productObj.varietyCode;
          obj['createTs'] = moment();
        } else {
          obj['createTs'] = moment();
          obj['commonName'] = this.productObj.commonName;
          // obj['technicalName'] = this.productObj.technicalName;
          obj['technicalName'] = this.selectedTechnicalName;
          obj['chemicalCode'] = this.productObj.chemicalCode;
          obj['chemicalId'] = this.selectedProductId;
        }
        this.multiArray.push(obj);
      }
      pobj = this.multiArray;
      this.inputsService.savemultipleProducts(pobj).then((data: any) => {
        if (data) {
          Swal({ title: "Saved successfully" })
          this.getAllSeeds();
          this.getAllFertilizers();
          this.getAllPesticides();
          this.cropuuid = '';
          this.ProductForm.reset();
          this.imageNameList = [];
          this.urls = [];
          this.uploadFileList = [];
          this.uploadMultipleFileList = [];
          this.tempArray = [];
          this.sizesArray = [];
          this.multiArray = [];
          this.size = null;
          this.showDetails = true;
          this.showcrop[1] = false;
          this.showcrop[2] = false;
          this.showvariants = false;
          this.productType = null;
          this.loading = false;
        } else {
          this.loading = false;
          Swal.fire(
            'Error',
            'Data not Submitted (please contact admin)',
            'error'
          )
        }
      })
    }
  }
  deleteSize(index) {
    this.sizesArray.splice(index, 1);
  }
  updateData() {
    this.loading = true;
    this.productObj.size = this.sizesArray && this.sizesArray.length > 0 ? this.sizesArray[0].size : this.size;
    this.productObj.price = this.sizesArray && this.sizesArray.length > 0 ? this.sizesArray[0].price : this.price;
    this.productObj.unit = this.sizesArray && this.sizesArray.length > 0 ? this.sizesArray[0].unit : this.unit;
    this.productObj.productImages = this.imageNameList;
    if (this.imageUploadService && this.imageUploadService.length > 0) {
      this.uploadFileToActivity();
    }
    if (this.selectedTechnicalName) {
      this.productObj['technicalName'] = this.selectedTechnicalName;
    }
    delete this.productObj._id
    this.inputsService.updateproductData(this.productObj).then((data: any) => {
      if (data) {
        this.cropuuid = '';
        this.getAllSeeds();
        this.getAllFertilizers();
        this.getAllPesticides();
        this.ProductForm.reset();
        this.imageNameList = [];
        this.urls = [];
        this.uploadFileList = [];
        this.uploadMultipleFileList = [];
        this.tempArray = [];
        this.sizesArray = [];
        this.multiArray = [];
        this.size = null;
        this.showDetails = true;
        this.showcrop[1] = false;
        this.showcrop[2] = false;
        this.showvariants = false;
        this.productType = null;
        this.loading = false;
        Swal({ title: "Updated successfully" })
      } else {
        this.loading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  onClickTopTab(event) {
    if (event == 'seeds') {
      this.typeId = 'seeds';
      this.inputType = 'seeds'
      this.showsearchdata = true;
      this.getAllSeeds();
    } else if (event == 'fertilizers') {
      this.inputType = 'fertilizers'
      this.getFertilizerData();
      this.typeId = 'fertilizers';
      this.showsearchdata = true;
      this.getAllFertilizers();
    } else if (event == 'pesticides') {
      this.inputType = 'pesticides'
      this.getFertilizerData();
      this.typeId = 'pesticides';
      this.showsearchdata = true;
      this.getAllPesticides();
    }
  }

  searchByName() {
    if (this.searchStr != '') {
      this.loading = true;
      var obj = {
        group: this.groupName,
        field: 'productName',
        text: this.searchStr,
        tableName: 'productcoll',
      };
      this.inputsService.getProductcollRegex(obj).then((data: any) => {
        this.searchStr = '';
        if (data.length > 0) {
          if (this.typeId == 'seeds') {
            this.seedsDataArray = [];
            this.seedsDataArray = data.filter(item => item.productType == 'Seeds');
          } else if (this.typeId == 'fertilizers') {
            this.fertilizersDataArray = [];
            this.fertilizersDataArray = data.filter(item => item.productType == 'Fertilizer');
          } else if (this.typeId == 'pesticides') {
            this.pesticidesDataArray = [];
            this.pesticidesDataArray = data.filter(item => item.productType == 'Pesticides');
          }
          this.showsearchdata = false;
          this.loading = false;
        }
        else {
          this.showsearchdata = false;
          this.loading = false;
        }
      })
    }
  }
}